const SALES_RECORD_TYPE = {
  /**
   * 地物
   */
  LOCAL: 1,
  /**
   * 地物・コンテナ借
   */
  // LOCAL_CONTAINER: 2,
  /**
   * 旅物
   */
  TRAVEL: 2,
  /**
   * 在庫
   */
  STOCK: 3,
};
export { SALES_RECORD_TYPE };
export default SALES_RECORD_TYPE;
